import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Home from '@/views/home/index'
import notFound from '@/views/404'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.ROUTER_BASE,
  routes: [
    {
      path: '/',
      redirect: 'index'
    },
    {
      path: '/404',
      name: '404',
      component: notFound,
      meta: {
        pageTitle: '错误页面',
        hideFlag: true
      }
    },
    {
      path: '/index',
      name: 'index',
      component: Home,
      meta: {
        pageTitle: '首页'
      }
    },
    {
      path: '/search/:searchKey',
      name: 'search',
      component: () => import('@/views/home/search'),
      meta: {
        pageTitle: '全局搜索'
      }
    },
    {
      path: '/topic_list/:id',
      name: 'topic_list',
      component: () => import('@/views/topic/list'),
      meta: {
        pageTitle: '专题列表'
      }
    },
    {
      path: '/topic_detail/:subjectCode/:id',
      name: 'topic_detail',
      component: () => import('@/views/topic/detail'),
      meta: {
        pageTitle: '专题详情'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js